import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login';
import Main from '../views/Main';
import CrewSearch from '@/views/administrator/report2/CrewSearch';
import ManningReport from '@/views/administrator/report1/ManningReport';
import CrewPerManningReport from '@/views/administrator/report3/CrewPerManningReport';
import UserMemoView from "@/views/UserMemoView";
import CrewLog from '@/views/administrator/report2/CrewLog';
import CrewActivity from '@/views/administrator/report2/CrewActivity';
import MemoUpload from '@/views/administrator/MemoUpload';
import Home from '@/views/main/Home'
import TestTreeTable from "@/views/main/TestTreeTable";
import TestPdfView from "@/views/TestPdfView";

Vue.use(VueRouter);

const routes = [
  {path: '/',
    name: 'Login',
    component: Login,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/m',
    name: 'Main',
    component: Main,
    redirect: '/m/home',
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/m/home',
        name: 'Home',
        component: Home,
        meta: {
          requiresAuth: true,
        }
      },
      {
        path: '/m/user-memo-view',
        name: 'UserMemoView',
        component: UserMemoView,
        meta: {
          requiresAuth: true,
        }
      },
      // {
      //   path: '/m/test',
      //   name: 'Test',
      //   component: TestTreeTable,
      //   meta: {
      //     requiresAuth: true,
      //   }
      // },
      {
        path: '/m/crew-search',
        name: 'CrewSearch',
        component: CrewSearch,
        meta: {
          requiresAuth: true,
        }
      },

      {
        path: '/m/manning-report',
        name: 'ManningReport',
        component: ManningReport,
        meta: {
          requiresAuth: true,
        }
      },

      {
        path: '/m/crew-per-manning',
        name: 'CrewPerManningReport',
        component: CrewPerManningReport,
      },

      {
        path: '/m/crew-logs/:crewId',
        name: 'CrewLog',
        component: CrewLog,
        meta: {
          requiresAuth: true,
        },
        prop: (route) => {
          const crewId = Number.parseInt(route.params.crewId, 10);
          if (Number.isNaN(crewId)) {
            return 0;
          }
          return {crewId};
        },
      },

      {
        path: '/m/crew-activity/:crewLogId',
        name: 'CrewActivity',
        component: CrewActivity,
        meta: {
          requiresAuth: true,
        },
        prop: (route) => {
          const crewLogId = Number.parseInt(route.params.crewLogId, 10);
          if (Number.isNaN(crewLogId)) {
            return 0;
          }
          return {crewLogId};
        },
      },

      {
        path: '/m/memo-upload',
        name: 'MemoUpload',
        component: MemoUpload,
        meta: {
          requiresAuth: true,
        },

      },
      {
        path: '/m/view/:type/:id',
        name: 'ViewFile',
        component: TestPdfView,
        meta: {
          requiresAuth: true,
        },
      },



    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});


router.beforeEach((to,from,next)=>{
  if (to.matched.some(record => record.meta.requiresAuth === true)) {
    //AUTH
    if (localStorage.getItem('krbs_circular_token') != null) {
      next();
    }
    else {
      next({name:'Login'});
    }

  } else {
    //GUEST
    if(!localStorage.getItem('krbs_circular_token') ){
      next();
    }
    else{
      next({name:'Home'});
    }
  }
})



export default router;
